import { API_URL } from './config'

interface Ingredient {
  section: string
  name: string
}

export interface Recipe {
  id: number
  name: string
  ingredients: Ingredient[]
}

export interface Cuisine {
  cuisine: string
  recipes: Recipe[]
}

export const getRecipes = async (): Promise<Cuisine[] | null> => {
  try {
    const response = await fetch(`${API_URL}/recipes`, {
      headers: { 'X-Secret-Key': localStorage.getItem('secret-key') ?? '' },
    })
    if (response.ok) return response.json()
  } catch (error) {
    console.error(error)
  }

  return null
}

export const addRecipe = async (
  index: string,
  name: string,
  ingredients: Ingredient[],
): Promise<number | null> => {
  try {
    const formData = {
      index,
      name,
      ingredients,
    }
    const response = await fetch(`${API_URL}/recipes/new`, {
      method: 'POST',
      body: JSON.stringify(formData),
      headers: { 'X-Secret-Key': localStorage.getItem('secret-key') ?? '' },
    })
    if (response.ok) {
      const json = await response.json()
      return Number(json.id)
    }
  } catch (error) {
    console.error(error)
  }

  return null
}

export const editRecipe = async (
  index: string,
  id: string,
  name: string,
  ingredients: Ingredient[],
): Promise<boolean> => {
  try {
    const formData = {
      name,
      ingredients,
    }
    const response = await fetch(`${API_URL}/recipes/edit/${index}/${id}`, {
      method: 'POST',
      body: JSON.stringify(formData),
      headers: { 'X-Secret-Key': localStorage.getItem('secret-key') ?? '' },
    })
    return response.ok
  } catch (error) {
    console.error(error)
  }

  return false
}

export const addToShoppingList = async (id: number): Promise<boolean> => {
  try {
    const response = await fetch(`${API_URL}/go-shopping/${id}`, {
      headers: { 'X-Secret-Key': localStorage.getItem('secret-key') ?? '' },
    })
    return response.ok
  } catch (error) {
    console.error(error)
  }

  return false
}

const SECTIONS = {
  '63g8Hc9C89qJHrV9': {
    order: 2,
    name: 'Fruit Veg',
  },
  '63g8g64fxMF94qJh': {
    order: 3,
    name: 'Meat',
  },
  '63g8QW3Wvw5mH689': {
    order: 4,
    name: 'Deli',
  },
  '63g8MwM7RgQQxR3h': {
    order: 5,
    name: 'Dairy',
  },
  '63g8CCVfjgvwhr59': {
    order: 6,
    name: 'Cereals spreads breads',
  },
  '63g8HmGcjr95RWrh': {
    order: 7,
    name: 'Snacks',
  },
  '63g8JGrvgghMf4r9': {
    order: 8,
    name: 'Pasta Asian Mexican tins spices',
  },
  '69PXX4j8HpHPHxC9': {
    order: 9,
    name: 'Baking and tins',
  },
  '6CrcwxC4Whh6VHXh': {
    order: 10,
    name: 'Medicine, frozen & cleaning',
  },
}

export const sections = Object.entries(SECTIONS).sort(
  (a, b) => a[1].order - b[1].order,
)
